module.exports = __webpack_public_path__ + "static/media/parcours-combattant.4aebe97a.jpg";